import FolderIcon from '@mui/icons-material/Folder';
import StreetviewIcon from '@mui/icons-material/Streetview';
import WorkIcon from '@mui/icons-material/Work';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { Link } from "react-router-dom";
import { tss } from "tss-react";
import { viewCardBackground } from "styles/common";

export const useStyles = tss.create(() => ({
    card: {
        display: 'flex',
        padding: '30px 20px 20px',
        backgroundColor: viewCardBackground,
        textAlign: 'center',
        overflow: 'hidden',
        position: 'relative',
        justifyContent: 'center',
        //alignItems: 'center',
        fontFamily: 'tahoma',
        width: 240,
        height: 305,
        //borderRadius: '15px',
        boxShadow: '0 3px 6px rgba(0,0,0,0.12), 0 3px 6px rgba(0,0,0,0.19)',
        " & .picture": {
            display: 'inline-flex',
            height: '130px',
            width: '130px',
            marginBottom: '10px',
            zIndex: 1,
            position: 'relative',
            alignItems: 'center',
            justifyContent: 'center',
            " &::before": {
                content: '""',
                width: '100%',
                height: 0,
                borderRadius: '50%',
                backgroundColor: '#02578E',
                position: 'absolute',
                bottom: '135%',
                right: 0,
                left: 0,
                opacity: 0.9,
                transform: 'scale(3)',
                transition: 'all 0.3s linear 0s'
            },
            " &::after": {
                content: '""',
                width: '100%',
                height: '100%',
                borderRadius: '50%',
                backgroundColor: 'rgba(32,32,32,.15)',
                position: 'absolute',
                top: 0,
                left: 0,
                zIndex: '-1',
            },
            img: {
                width: '100%',
                height: 'auto',
                borderRadius: '50%',
                transform: 'scale(1)',
                transition: 'all 0.9s ease 0s'
            },
            " & .MuiSvgIcon-root": {
                width: '5rem',
                height: '5rem',
                color: '#02578E',
                position: 'absolute',
                zIndex: 99999,
                transition: 'all 0.3s ease 0s',
            },
        },
        " & .buttons": {
            width: '100%',
            padding: 0,
            margin: 0,
            backgroundColor: '#02578E',
            position: 'absolute',
            bottom: '-100px',
            left: 0,
            transition: 'all 0.5s ease 0s',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            " & ul": {
                padding: 0,
                margin: 0,
                " & li": {
                    display: 'inline-block',
                    height: 33,
                    " & a": {
                        display: 'block',
                        padding: '10px',
                        fontSize: '17px',
                        color: 'white',
                        transition: 'all 0.3s ease 0s',
                        textDecoration: 'none',
                        "&:hover": {
                            color: '#02578E',
                            backgroundColor: '#28ABE3',
                            " & .MuiSvgIcon-root": {
                                color: 'rgba(255,255,255,.8)'
                            }
                        }
                    }
                }
            }
        },
        " & .link": {
            textDecoration: "none"
        },
        " & .card-content": {
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
            gap: '10px'
        },
        " & .name": {
            fontSize: '1.1rem',
            margin: 0,
            padding:0,
            fontFamily: 'inherit',
            fontWeight: 500,
            lineHeight: '1.5rem',
            color: '#010101',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            display: '-webkit-box',
            WebkitLineClamp: 2,
            lineClamp: 2 ,
            WebkitBoxOrient: 'vertical'
        },
        " & .description": {
            fontSize: '13px',
            color: '#4e5052',
            fontWeight:300,
            margin: 0,
            padding:0,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            display: '-webkit-box',
            WebkitLineClamp: 2,
            lineClamp: 2 ,
            WebkitBoxOrient: 'vertical'
        },
        " &:hover": {  
            " & .picture": {
                " &::before": {
                    height: '100%'
                },
                " &::after": {
                    backgroundColor: '#02578E',
                },
                " & img": {
                    boxShadow: '0 0 0 14px #28ABE3',
                    transform: 'scale(0.7)'
                },
                " & .MuiSvgIcon-root": {
                    color: 'rgba(255,255,255,.85)'
                },
            },
            " & .buttons": {
                bottom: 0
            },
            " & .link": {
                textDecoration: "none"
            },
        }
    }
}));

type IProps = {
    project: any;
};

const ProjectCard = (props: IProps) => {
    const { classes } = useStyles();
    const { ID:projectID, name:projectName = 'Unknown Project', description:projectDescription = '', image = '' } = props.project;
    return (
        <div className={classes.card}>
            <div className="cardContent">
                <Link to={`${projectID}/catalog`} className="link">
                    <div className="picture">
                        {image ? (
                            <img className="img-fluid" src={image} />
                        ) : (
                            <FolderIcon sx={{ fontSize: 35 }} />
                        )}
                    </div>
                    <div className="card-content">
                        <h3 className="name">{projectName}</h3>
                        <h4 className="description">{projectDescription}</h4>
                    </div>
                </Link>
                <div className="buttons">
                    <ul>
                        <li>
                            <a href={`${projectID}/catalog`} className="btn" aria-hidden="true" title="Catalog">
                            <WorkIcon sx={{ fontSize: 20 }} />
                            </a>
                        </li>
                        <li>
                            <a href={`${projectID}/views`} className="btn" aria-hidden="true" title="Views">
                            <StreetviewIcon sx={{ fontSize: 20 }} />
                            </a>
                        </li>
                    </ul>
                    <ul>
                        <li>
                            <a href="#" className="btn" aria-hidden="true" title="Edit">
                                <EditIcon sx={{ fontSize: 20 }} />
                            </a>
                        </li>
                        <li>
                            <a href="#" className="btn" aria-hidden="true" title="Delete">
                                <DeleteIcon sx={{ fontSize: 20 }} />
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    );
}

export default ProjectCard;
